import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { passwordMatchValidator } from '@app/_helpers/passwordValidator';

import { AccountService, AlertService } from '@app/_services';
import { AutomationService } from '@app/_services/automation.service';

@Component({
  selector: 'app-automation-request',
  templateUrl: './automation-request.component.html',
  styleUrls: ['./automation-request.component.less']
})
export class AutomationRequestComponent implements OnInit {
  rgFrmGrp: FormGroup;
  isLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private automationService: AutomationService,
    private router: Router,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.rgFrmGrp = this.formBuilder.group({
      name: ['', [Validators.required]],
      emailId: ['', Validators.compose([Validators.required,Validators.email])],
      companyName: ['', [Validators.required]],
    });
  }
  /* Shorthands for form controls (used from within template) */
  get f() { return this.rgFrmGrp.controls; }

  onSubmitMemberInfo() {
    if (this.rgFrmGrp.valid) {
      this.isLoading = true;
      const payLoad = this.rgFrmGrp.value;
      this.automationService.sendAutomationRequestToSherpa(payLoad).subscribe((status: boolean) => {
        this.isLoading = false;
        if(status){
          this.alertService.success('Request created successfully', { keepAfterRouteChange: true });
          this.router.navigateByUrl('/information');
          this.rgFrmGrp.reset();
        }
      }, error => {
        this.isLoading = false;
      })
    }
  }
}
